import styles from "./index.module.scss";

const MobileHeader = () => {
  return (
    <div className={styles.container}>
      <div className={styles.brand}>
        <div className={styles.logo} />
        <div className={styles.brandName}>PythonTip</div>
      </div>
    </div>
  );
};

export default MobileHeader;
